import { createAction } from '@mendeley-internal/lib-js-redux-actions';

export const setConfig = createAction('SET_CONFIG');



// WEBPACK FOOTER //
// ./src/universal/ui/actions/config.js